import React from "react";
import DrawerModal from "~/common/DrawerModal";
import { getSortByValueFromUrl, updateUrlSortBy } from "./SortByHelpers";
interface Props {
  pageUrl: string;
  includeRelevancy?: boolean;
  includeMostPopular?: boolean;
  toggleShowMobileSortFilter: () => void;
  sortByMobileDialogRef: React.RefObject<HTMLDialogElement>;
}
const MobileSortBy = ({
  pageUrl,
  toggleShowMobileSortFilter,
  includeRelevancy = false,
  includeMostPopular = true,
  sortByMobileDialogRef
}: Props) => {
  let currentSortByValue = getSortByValueFromUrl(pageUrl);
  if (!currentSortByValue) {
    currentSortByValue = includeRelevancy ? "relevancy_desc" : "popular";
  }
  const sortByOptions = [...(includeRelevancy ? [{
    label: "Relevance",
    value: "relevancy_desc"
  }] : []), ...(includeMostPopular ? [{
    label: "Most Popular",
    value: "popular"
  }] : []), {
    label: "Price: Low to High",
    value: "price_asc"
  }, {
    label: "Price: High to Low",
    value: "price_desc"
  }, {
    label: "Rating: Low to High",
    value: "rating_asc"
  }, {
    label: "Rating: High to Low",
    value: "rating_desc"
  }, {
    label: "Date Added: Newest first",
    value: "date_desc"
  }, {
    label: "Date Added: Oldest first",
    value: "date_asc"
  }];
  return <DrawerModal dialogRef={sortByMobileDialogRef} title="Sort" id="sortOnMobile" dialogClasses="bg-zinc-100" rightControlContent="Cancel" rightControlFunction={toggleShowMobileSortFilter} data-sentry-element="DrawerModal" data-sentry-component="MobileSortBy" data-sentry-source-file="MobileSortBy.tsx">
      <>
        <ul className="filter-list box border-t border-solid border-[#dbdfd8]">
          <li className="filter-list__section">
            {sortByOptions.map(sortByOption => {
            const isCurrentSortByActive = sortByOption.value === currentSortByValue;
            return <a href={updateUrlSortBy(pageUrl, sortByOption.value)} className={`filter-list__heading filter-list__heading--link text-base leading-none${isCurrentSortByActive ? " active" : ""} focus:z-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-6px]`} key={sortByOption.value}>
                  {sortByOption.label}
                  {isCurrentSortByActive && <div className="list-check" />}
                </a>;
          })}
          </li>
        </ul>
      </>
    </DrawerModal>;
};
export default MobileSortBy;